import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ComponentStatus, StateComponent } from '../../../../../../../common/components/state/state.component';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CompetitionGroupApiService } from '../../../../../../../common/apis/competition-group/competition-group-api.service';
import { MatIcon } from '@angular/material/icon';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { LoadingContainerComponent } from '../../../../../../../common/components/loading-container/loading-container.component';

@Component({
  selector: 'oo-participants-link-dialog',
  templateUrl: './participants-link-dialog.component.html',
  styleUrls: ['./participants-link-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    LoadingContainerComponent,
    MatDialogTitle,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatInput,
    MatIconButton,
    MatSuffix,
    MatIcon,
    MatDialogActions,
    MatButton,
    MatDialogClose,
  ],
})
export class ParticipantsLinkDialogComponent extends StateComponent<ParticipantsLinkDialogComponentState> implements OnInit {

  private readonly dialogRef = inject<MatDialogRef<ParticipantsLinkDialogComponent>>(MatDialogRef);
  private readonly compGroupApi = inject(CompetitionGroupApiService);
  private readonly snackBar = inject(MatSnackBar);
  private readonly data = inject<ParticipantsLinkDialogComponentData>(MAT_DIALOG_DATA);

  state: ParticipantsLinkDialogComponentState = {
    status: 'ready',
    compGroupId: this.data.compGroupId,
    link: '',
  };


  ngOnInit(): void {
    this.dialogRef.updateSize('300px', '380px');
    this.fetchData();
  }

  async copyLink(): Promise<void> {
    await navigator.clipboard.writeText(this.state.link);
    this.snackBar.open('Link copied to clipboard', 'DISMISS', { duration: 3000 });
  }

  private fetchData(): void {
    this.updateStatus('loading');
    this.compGroupApi.getCompGroupInfo(this.state.compGroupId, ['inviteLink', 'tournamentStarted'])
      .then(({ inviteLink }) => {
        this.updateState({
          status: 'ready',
          link: inviteLink,
        });
      })
      .catch((e: Error) => {
        console.error(e);
        this.updateStatus('error');
      });
  }
}

interface ParticipantsLinkDialogComponentState {
  status: ComponentStatus;
  compGroupId: string;
  link: string;
}

export interface ParticipantsLinkDialogComponentData {
  compGroupId: string;
}
